import Translator from '../../classes/Translator/Translator';
import { useHistory } from 'react-router-dom';

const OurServicesLogic = () => {
  const { translator } = Translator();
  const history = useHistory();
  const goTo = (route) => () => {
    return history.push(route);
  };

  return {
    translator,
    goTo,
  };
};

export default OurServicesLogic;
